<template>
	<div style="width:100%;">



		<div id="grid" style="width:100%;padding-top:10px;padding-bottom:10px;">

			<Card class="card link" title="Visa våra motorcykelprodukter"
				@click.stop="this.routerShowProductListForUrlKey('mc')" filename="mc.jpg" cardtitle="MOTORCYKEL"
				subtitle="boove.se/mc" :tint="true" position="top left" />

			<Card class="card link" title="Visa våra cykelprodukter"
				@click.stop="this.routerShowProductListForUrlKey('cykel')" filename="cykel1.jpg" cardtitle="CYKEL"
				subtitle="www.boove.se/cykel" :tint="true" />
			<Card class="link" title="Visa våra olje/smörj-produkter"
				@click.stop="this.routerShowProductListForUrlKey('olja')" filename="olja1.jpg" cardtitle="OLJA"
				subtitle="www.boove.se/olja" :tint="true" position="center center" />

			<Card class="card link" title="Hitta din återförsäljare" @click="this.routerShowReseller()"
				text="HITTA DIN BUTIK" />

			<Card class="card link" title="" background="#333333" cardtitle="OUTLET" @click="this.$emit('gotoStart', 'start-outlet')" />



		</div>

		<div v-if="!this" class="flexcenter" style="gap:10px;height:300px;width:100%;padding-top:10px;padding-bottom:10px;">

			<Card class="link" title="Visa våra motorcykelprodukter" @click.stop="this.routerShowProductListForUrlKey('mc')"
				filename="mc.jpg" cardtitle="MOTORCYKEL" subtitle="boove.se/mc" :tint="true" position="top left" />

			<Card class="link" title="Visa våra cykelprodukter" @click.stop="this.routerShowProductListForUrlKey('cykel')"
				filename="cykel1.jpg" cardtitle="CYKEL" subtitle="www.boove.se/cykel" :tint="true" />
			<Card class="link" title="Visa våra olje/smörj-produkter"
				@click.stop="this.routerShowProductListForUrlKey('olja')" filename="olja1.jpg" cardtitle="OLJA"
				subtitle="www.boove.se/olja" :tint="true" position="center center" />

			<Card class="link" title="Hitta din återförsäljare" @click="this.routerShowReseller()" text="HITTA DIN BUTIK" />
			<Card class="link" title="" background="#333333" cardtitle="xx" @click="this.$emit('start-outlet')" />



		</div>

	</div>
</template>
<script>
import Card from '../../components/Card.vue';
import { STORE_COMMIT, STORE_GETTER } from '../../store/store';


//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
import { routerMixin } from "@/mixins/routerMixin.js";

export default {
	name: "ProductTypeView",
	components: { Card },
	mixins: [routerMixin],
	props: {

	},
	data() {
		return {

		};
	},
	computed: {


		productTypeModel() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL]
		},

		productTypeSelected() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED]

		},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {

		setProductTypeByKey(productTypeKey) {

			const productType = this.productTypeModel?.list?.find(productType => productType.key == productTypeKey);
			this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType)
			console.log('FP: productTypeKey', productTypeKey);
			
		},


	},
	created() {

	}
};
</script>

<style scoped>
div#grid {
	display: grid;
	grid-template-columns: repeat(5, calc((100% - 45px) / 5));
	grid-row: auto;
	column-gap: 10px;
	row-gap: 5px;
	border: 5px solid transparent;
	align-items: stretch;

}

div#grid div.card {
	min-height: 300px;
}

@media (max-width: 1068px) {

	div#grid {
		display: grid;
		grid-template-columns: auto auto auto;
	}

	div#grid div.card {
		min-height: 250px;
	}

}

@media (max-width: 768px) {

	div#grid {
		display: grid;
		grid-template-columns: auto auto ;
	}

	div#grid div.card {
		min-height: 250px;
	}

}
</style>